<!-- Backdrop -->
<div 
  *ngIf="isOpen" 
  class="modal-backdrop fixed inset-0 bg-black/60 dark:bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4"
  (click)="onBackdropClick($event)"
>
  <!-- Modal -->
  <!-- Inline: @keyframes slideUp definido no SCSS do componente — Tailwind não suporta keyframes customizados sem criar um utilitário dedicado -->
  <div 
    class="context-selector-modal bg-white dark:bg-gray-800 rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 z-50 w-full max-w-5xl max-h-[90vh] overflow-y-auto"
    style="animation: slideUp 0.2s ease-out;"
    (click)="$event.stopPropagation()"
  >
    <div class="sticky top-0 bg-gradient-to-br from-white via-orange-50 to-amber-50 dark:from-slate-800 dark:via-slate-800 dark:to-slate-900 border-b-2 border-gray-200 dark:border-gray-700 px-6 py-5 flex items-center justify-between z-10">
      <div class="flex items-center space-x-3">
        <div class="flex-shrink-0 w-10 h-10 rounded-lg bg-gradient-to-br from-blue-500 to-blue-600 dark:from-blue-600 dark:to-blue-700 flex items-center justify-center shadow-lg">
          <lucide-icon name="refresh-cw" class="w-5 h-5 text-white"></lucide-icon>
        </div>
        <h3 class="text-xl font-bold text-gray-900 dark:text-white">{{ canClose ? 'Alterar contexto' : 'Selecionar contexto' }}</h3>
      </div>
      <button
        *ngIf="canClose"
        (click)="fechar()"
        class="text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 transition-colors flex-shrink-0"
        title="Fechar"
      >
        <lucide-icon name="x" class="w-5 h-5"></lucide-icon>
      </button>
    </div>

    <div class="p-6 space-y-5">
      <!-- Indicador de carregamento -->
      <div *ngIf="carregando" class="flex items-center justify-center space-x-2 py-8">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        <span class="text-sm text-gray-600 dark:text-gray-400">Carregando dados...</span>
      </div>

      <!-- Conteúdo do modal (oculto durante carregamento) -->
      <div *ngIf="!carregando">
        <!-- Mensagem de erro -->
        <div *ngIf="erro" class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-red-700 dark:text-red-400 px-4 py-3 rounded-lg text-sm mb-4">
          {{ erro }}
        </div>

      <!-- Entidade -->
      <p *ngIf="semOpcoesEntidades()" class="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-1.5 mb-1">
        <lucide-icon name="info" class="w-3.5 h-3.5 flex-shrink-0"></lucide-icon>
        {{ msgSemOpcoes.entidades }}
      </p>

      <app-hierarquia-select
        label="Entidade"
        [options]="entidadesFiltradas"
        [getOptionId]="getOptionId"
        [getOptionLabel]="getEntidadeLabel"
        [selectedId]="entidadeSelecionada"
        [isOpen]="entidadeDropdownAberto"
        [disabled]="carregando || entidades.length === 0 || entidadeDesabilitada"
        [hideClear]="entidadeDesabilitada"
        [buttonText]="getEntidadeSelecionadaTexto()"
        [buttonTextMuted]="semOpcoesEntidades()"
        [(searchTerm)]="entidadeSearchTerm"
        searchPlaceholder="Buscar entidade..."
        noResultsText="Nenhuma entidade encontrada"
        (toggleRequested)="toggleEntidadeDropdown()"
        (searchChanged)="filtrarEntidades()"
        (searchCleared)="limparBuscaEntidade()"
        (optionSelected)="selecionarEntidade($event)"
        (clearRequested)="limparEntidadeField()"
      ></app-hierarquia-select>

      <!-- Servidor: oculto para professor (auto-preenchido, não precisa selecionar) -->
      <div *ngIf="!servidorProfessorVinculado && !detectandoServidorProfessor">
        <p *ngIf="semOpcoesServidores()" class="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-1.5">
          <lucide-icon name="info" class="w-3.5 h-3.5 flex-shrink-0"></lucide-icon>
          {{ msgSemOpcoes.servidores }}
        </p>

        <!-- Mensagem quando desabilitado por entidade não selecionada (omitida se já há mensagem de lista vazia em cascata) -->
        <p *ngIf="!camposHabilitados.servidor && !servidorProfessorVinculado && !semOpcoesServidores()" class="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-1">
          <lucide-icon name="info" class="w-3 h-3"></lucide-icon>
          Selecione uma entidade primeiro
        </p>

        <!-- Mensagem quando servidor vinculado automaticamente ao professor -->
        <p *ngIf="servidorProfessorVinculado" class="text-xs text-blue-600 dark:text-blue-400 flex items-center gap-1">
          <lucide-icon name="lock" class="w-3 h-3"></lucide-icon>
          Servidor vinculado automaticamente ao seu perfil
        </p>

        <!-- Indicador de loading -->
        <div *ngIf="loadingStates.servidores" class="flex items-center gap-2 text-xs text-blue-600 dark:text-blue-400 mb-1">
          <div class="animate-spin rounded-full h-3 w-3 border-b border-blue-600 dark:border-blue-400"></div>
          <span>Carregando servidores...</span>
        </div>

        <app-hierarquia-select
          label="Servidor"
          [options]="servidoresFiltrados"
          [getOptionId]="getOptionId"
          [getOptionLabel]="getServidorLabel"
          [selectedId]="servidorSelecionado"
          [isOpen]="servidorDropdownAberto"
          [disabled]="!camposHabilitados.servidor || loadingStates.servidores || servidores.length === 0 || servidorProfessorVinculado"
          [hideClear]="servidorProfessorVinculado"
          [buttonText]="getServidorSelecionadoTexto()"
          [buttonTextMuted]="semOpcoesServidores()"
          [(searchTerm)]="servidorSearchTerm"
          searchPlaceholder="Buscar servidor..."
          noResultsText="Nenhum servidor encontrado"
          (toggleRequested)="toggleServidorDropdown()"
          (searchChanged)="onServidorSearchChange($event)"
          (searchCleared)="limparBuscaServidor()"
          (optionSelected)="selecionarServidor($event)"
          (clearRequested)="limparServidorField()"
        ></app-hierarquia-select>
      </div>

      <!-- Ano Letivo -->
      <div>
        <p *ngIf="semOpcoesAnosLetivos()" class="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-1.5">
          <lucide-icon name="info" class="w-3.5 h-3.5 flex-shrink-0"></lucide-icon>
          {{ msgSemOpcoes.anoLetivo }}
        </p>

        <!-- Loading enquanto identifica se é professor (para não bloquear o campo com mensagem desnecessária) -->
        <div *ngIf="detectandoServidorProfessor" class="flex items-center gap-2 text-xs text-blue-600 dark:text-blue-400 mb-1">
          <div class="animate-spin rounded-full h-3 w-3 border-b border-blue-600 dark:border-blue-400"></div>
          <span>Identificando servidor...</span>
        </div>

        <!-- Mensagem quando desabilitado (omitida se já há mensagem de lista vazia em cascata) -->
        <p *ngIf="!camposHabilitados.anoLetivo && !detectandoServidorProfessor && !semOpcoesAnosLetivos()" class="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-1">
          <lucide-icon name="info" class="w-3 h-3"></lucide-icon>
          Selecione um servidor primeiro
        </p>

        <!-- Indicador de loading -->
        <div *ngIf="loadingStates.anosLetivos" class="flex items-center gap-2 text-xs text-blue-600 dark:text-blue-400 mb-1">
          <div class="animate-spin rounded-full h-3 w-3 border-b border-blue-600 dark:border-blue-400"></div>
          <span>Carregando anos letivos...</span>
        </div>

        <app-hierarquia-select
          label="Ano letivo"
          [options]="anosLetivosFiltrados"
          [getOptionId]="getOptionId"
          [getOptionLabel]="getAnoLetivoLabel"
          [selectedId]="anoLetivoSelecionado"
          [isOpen]="anoLetivoDropdownAberto"
          [disabled]="!camposHabilitados.anoLetivo || loadingStates.anosLetivos || anosLetivos.length === 0"
          [buttonText]="getAnoLetivoSelecionadoTexto()"
          [buttonTextMuted]="semOpcoesAnosLetivos()"
          [(searchTerm)]="anoLetivoSearchTerm"
          searchPlaceholder="Buscar ano letivo..."
          noResultsText="Nenhum ano letivo encontrado"
          (toggleRequested)="toggleAnoLetivoDropdown()"
          (searchChanged)="filtrarAnosLetivos()"
          (searchCleared)="limparBuscaAnoLetivo()"
          (optionSelected)="selecionarAnoLetivo($event)"
          (clearRequested)="limparAnoLetivoField()"
        ></app-hierarquia-select>
      </div>

      <!-- Estabelecimento -->
      <div>
        <p *ngIf="semOpcoesEstabelecimentos()" class="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-1.5">
          <lucide-icon name="info" class="w-3.5 h-3.5 flex-shrink-0"></lucide-icon>
          {{ msgSemOpcoes.estabelecimentos }}
        </p>

        <p *ngIf="!camposHabilitados.estabelecimento && !semOpcoesEstabelecimentos()" class="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-1 mb-2">
          <lucide-icon name="info" class="w-3 h-3 flex-shrink-0"></lucide-icon>
          Selecione um ano letivo primeiro
        </p>

        <!-- Indicador de loading -->
        <div *ngIf="loadingStates.estabelecimentos" class="flex items-center gap-2 text-xs text-blue-600 dark:text-blue-400 mb-1">
          <div class="animate-spin rounded-full h-3 w-3 border-b border-blue-600 dark:border-blue-400"></div>
          <span>Carregando estabelecimentos...</span>
        </div>

        <app-hierarquia-select
          label="Estabelecimento"
          [options]="estabelecimentosFiltrados"
          [getOptionId]="getOptionId"
          [getOptionLabel]="getEstabelecimentoLabel"
          [selectedId]="estabelecimentoSelecionado"
          [isOpen]="estabelecimentoDropdownAberto"
          [disabled]="!camposHabilitados.estabelecimento || loadingStates.estabelecimentos || estabelecimentos.length === 0"
          [buttonText]="getEstabelecimentoSelecionadoTexto()"
          [buttonTextMuted]="semOpcoesEstabelecimentos()"
          [(searchTerm)]="estabelecimentoSearchTerm"
          searchPlaceholder="Buscar estabelecimento..."
          noResultsText="Nenhum estabelecimento encontrado"
          (toggleRequested)="toggleEstabelecimentoDropdown()"
          (searchChanged)="filtrarEstabelecimentos()"
          (searchCleared)="limparBuscaEstabelecimento()"
          (optionSelected)="selecionarEstabelecimento($event)"
          (clearRequested)="limparEstabelecimentoField()"
        ></app-hierarquia-select>
      </div>

      <!-- Turma -->
      <div>
        <p *ngIf="semOpcoesTurmas()" class="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-1.5">
          <lucide-icon name="info" class="w-3.5 h-3.5 flex-shrink-0"></lucide-icon>
          {{ msgSemOpcoes.turmas }}
        </p>

        <p *ngIf="!camposHabilitados.turma && !semOpcoesTurmas()" class="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-1 mb-2">
          <lucide-icon name="info" class="w-3 h-3 flex-shrink-0"></lucide-icon>
          Selecione um estabelecimento primeiro
        </p>

        <!-- Indicador de loading -->
        <div *ngIf="loadingStates.turmas" class="flex items-center gap-2 text-xs text-blue-600 dark:text-blue-400 mb-1">
          <div class="animate-spin rounded-full h-3 w-3 border-b border-blue-600 dark:border-blue-400"></div>
          <span>Carregando turmas...</span>
        </div>

        <app-hierarquia-select
          label="Turma"
          [options]="turmasFiltradas"
          [getOptionId]="getOptionId"
          [getOptionLabel]="getTurmaLabel"
          [selectedId]="turmaSelecionada"
          [isOpen]="turmaDropdownAberta"
          [disabled]="!camposHabilitados.turma || loadingStates.turmas || turmas.length === 0"
          [buttonText]="getTurmaSelecionadaTexto()"
          [buttonTextMuted]="semOpcoesTurmas()"
          [(searchTerm)]="turmaSearchTerm"
          searchPlaceholder="Buscar turma..."
          noResultsText="Nenhuma turma encontrada"
          (toggleRequested)="toggleTurmaDropdown()"
          (searchChanged)="filtrarTurmas()"
          (searchCleared)="limparBuscaTurma()"
          (optionSelected)="selecionarTurma($event)"
          (clearRequested)="limparTurmaField()"
        ></app-hierarquia-select>
      </div>

      <!-- Componentes Curriculares -->
      <div class="space-y-1" *ngIf="exibirBlocoComponentesCurriculares()">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          {{ isTurmaSelecionadaAtividade() ? 'Componente curricular' : 'Componente(s) curricular(es)' }}
        </label>

        <p *ngIf="!camposHabilitados.componentes && !semOpcoesComponentes()" class="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-1 mb-1">
          <lucide-icon name="info" class="w-3 h-3 flex-shrink-0"></lucide-icon>
          Selecione uma turma primeiro
        </p>
        
        <!-- Indicador de loading -->
        <div *ngIf="loadingStates.componentes" class="flex flex-col items-center justify-center py-8 space-y-2">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 dark:border-blue-400"></div>
          <span class="text-sm text-blue-600 dark:text-blue-400">Carregando componentes curriculares...</span>
        </div>
        
        <!-- Conteúdo dos componentes -->
        <div *ngIf="!loadingStates.componentes && componentes.length > 0">
        <app-componentes-curriculares-select
          [componentes]="componentes"
          [selecaoUnica]="isSelecaoUnicaComponentes()"
          [enabled]="camposHabilitados.componentes"
        ></app-componentes-curriculares-select>
        </div><!-- Fim conteúdo componentes -->

        <!-- Sem componentes: mesmo padrão dos selects (texto auxiliar + área sombreada) -->
        <div
          *ngIf="semOpcoesComponentes()"
          class="space-y-1.5"
        >
          <p class="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-1.5">
            <lucide-icon name="info" class="w-3.5 h-3.5 flex-shrink-0"></lucide-icon>
            {{ msgSemOpcoes.componentes }}
          </p>
          <div
            class="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-sm text-gray-500 dark:text-gray-400"
          >
            {{ msgSemOpcoes.componentes }}
          </div>
        </div>
      </div>

      </div><!-- Fim do div *ngIf="!carregando" -->
    </div>

    <!-- Footer com botões -->
    <div class="sticky bottom-0 bg-white dark:bg-gray-900 border-t-2 border-gray-200 dark:border-gray-700 px-6 py-5 flex items-center justify-end space-x-3 shadow-lg z-20">
      <button
        (click)="aplicar()"
        type="button"
        [disabled]="carregando || !turmaSelecionada || getComponentesLength() === 0"
        class="px-6 py-2.5 text-sm font-bold text-white bg-gradient-to-r from-blue-500 to-blue-600 dark:from-blue-600 dark:to-blue-700 rounded-lg hover:from-blue-600 hover:to-blue-700 dark:hover:from-blue-700 dark:hover:to-blue-800 transition-all duration-200 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:from-blue-500 disabled:hover:to-blue-600"
      >
        {{ canClose ? 'Alterar' : 'Aplicar' }}
      </button>
      <button
        (click)="cancelar()"
        type="button"
        class="px-6 py-2.5 text-sm font-semibold text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 hover:border-gray-400 dark:hover:border-gray-500 transition-all duration-200 shadow-sm"
      >
        Cancelar
      </button>
    </div>
  </div>
</div>
